import React from 'react';
import { useNavigate } from 'react-router-dom';

import { getInnovationTextClasses } from '../../../configs/colors';

function ContactCard({ contact }) {
  const navigate = useNavigate();

  const {
    full_name: fullName,
    position,
    organization,
    email,
    phone_number: phoneNumber,
    address,
  } = contact;

  const detailValues = [
    position,
    organization,
    email,
    phoneNumber,
    address,
  ].filter(Boolean);

  const handleCardClick = () => {
    navigate('/contacts/details', { state: { contact } });
  };

  return (
    <article
      onClick={handleCardClick}
      className="rounded-3xl bg-white/5 border border-white/10 shadow-xl shadow-black/30 overflow-hidden transition-transform hover:-translate-y-1 cursor-pointer"
    >
      <div className="p-6 space-y-3">
        <h3 className={`text-lg font-semibold ${getInnovationTextClasses()}`}>
          {fullName || 'Unnamed contact'}
        </h3>
        {detailValues.map((value, index) => (
          <p key={index} className="text-sm text-gray-200">
            {value}
          </p>
        ))}
      </div>
    </article>
  );
}

export default function ContactListContent({ contacts }) {
  return (
    <div className="grid gap-6 md:grid-cols-2">
      {contacts.map((contact, index) => (
        <ContactCard key={contact.image_url || `${contact.username}-${index}`} contact={contact} />
      ))}
    </div>
  );
}


